import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEOHead } from '../components/SEOHead';

export default function PrivacyPage() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <Navbar />
      <SEOHead
        titleES="Política de Privacidad — Colegio ARCE"
        titleEN="Privacy Policy — Colegio ARCE"
        descES="Política de privacidad de Colegio ARCE. Cómo recopilamos, usamos y protegemos tu información."
        descEN="Privacy policy for Colegio ARCE. How we collect, use, and protect your information."
        path="/privacy"
      />
      <main className="pt-40 pb-20 px-6" data-testid="privacy-page">
        <article className="max-w-3xl mx-auto prose prose-sm">
          <h1 className="text-3xl font-semibold text-[#1D1D1F] mb-8">
            {language === 'es' ? 'Política de Privacidad' : 'Privacy Policy'}
          </h1>
          <p className="text-xs text-[#86868B] mb-8">
            {language === 'es' ? 'Última actualización: febrero 2026' : 'Last updated: February 2026'}
          </p>

          {language === 'es' ? (
            <div className="space-y-6 text-sm text-[#1D1D1F] leading-relaxed">
              <section>
                <h2 className="text-lg font-semibold mb-2">1. Información que recopilamos</h2>
                <p>Colegio ARCE (ARCE SPANISH SCHOOL, LLC.) recopila información personal proporcionada voluntariamente por los padres o tutores legales a través de nuestros formularios de inscripción y contacto. Esta información incluye: nombre completo del padre/tutor y del alumno, dirección de correo electrónico, número de teléfono, fecha de nacimiento del alumno y nivel escolar.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">2. Uso de la información</h2>
                <p>Utilizamos la información recopilada exclusivamente para fines de comunicación escolar, gestión de inscripciones, programación de clases, evaluaciones de nivel y envío de información relevante sobre nuestros servicios educativos.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">3. Compartir con terceros</h2>
                <p>No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto cuando sea necesario para procesar pagos (Stripe, Inc.) o cuando lo requiera la ley.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">4. Cookies</h2>
                <p>Nuestro sitio web utiliza cookies de sesión únicamente para mantener tu sesión activa mientras navegas. No utilizamos cookies de seguimiento ni de publicidad.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">5. Protección de menores (COPPA)</h2>
                <p>Colegio ARCE cumple con la Ley de Protección de la Privacidad en Línea de los Niños (COPPA). No recopilamos información directamente de menores de 13 años. Toda la información de los alumnos es proporcionada por sus padres o tutores legales.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">6. Contacto</h2>
                <p>Para preguntas sobre esta política de privacidad, contáctanos en: <a href="mailto:laura@colegioarce.com" className="text-[#E63946] hover:underline">laura@colegioarce.com</a></p>
              </section>
            </div>
          ) : (
            <div className="space-y-6 text-sm text-[#1D1D1F] leading-relaxed">
              <section>
                <h2 className="text-lg font-semibold mb-2">1. Information We Collect</h2>
                <p>Colegio ARCE (ARCE SPANISH SCHOOL, LLC.) collects personal information voluntarily provided by parents or legal guardians through our enrollment and contact forms. This includes: parent/guardian full name and student name, email address, phone number, student date of birth, and grade level.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">2. How We Use Your Information</h2>
                <p>We use collected information exclusively for school communication, enrollment management, class scheduling, level assessments, and sending relevant information about our educational services.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">3. Sharing With Third Parties</h2>
                <p>We do not sell, rent, or share your personal information with third parties, except as necessary to process payments (Stripe, Inc.) or as required by law.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">4. Cookies</h2>
                <p>Our website uses session cookies only to maintain your session while browsing. We do not use tracking or advertising cookies.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">5. Children's Privacy (COPPA)</h2>
                <p>Colegio ARCE complies with the Children's Online Privacy Protection Act (COPPA). We do not collect information directly from children under 13. All student information is provided by their parents or legal guardians.</p>
              </section>
              <section>
                <h2 className="text-lg font-semibold mb-2">6. Contact</h2>
                <p>For questions about this privacy policy, contact us at: <a href="mailto:laura@colegioarce.com" className="text-[#E63946] hover:underline">laura@colegioarce.com</a></p>
              </section>
            </div>
          )}
        </article>
      </main>
      <Footer />
    </div>
  );
}
